import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { DocsComponentName } from "../constant";
import { getExtensionSafe } from "../utils";

/**
 * 打开文档大小面板
 */
export var openDocSizePanel = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
    var extension;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getExtensionSafe(DocsComponentName.DOC_SIZE);
        case 2:
          extension = _context.sent;
          extension.show(options);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function openDocSizePanel(_x) {
    return _ref.apply(this, arguments);
  };
}();